import { useCallback, useState } from 'react';

import { CodeLanguageType } from '../../components/Code/types';

// use useLanguageContext to subscribe to changes
export function useLanguagePreference(
  prefix: string = '',
  defaultLanguage: CodeLanguageType = 'yaml'
) {
  const [language, setLanguage] = useState<CodeLanguageType>(() => {
    const pref =
      localStorage.getItem(`ls:ui:${prefix}code_language`) ?? defaultLanguage;
    if (['yaml', 'json'].includes(pref)) {
      return pref as CodeLanguageType;
    }
    return defaultLanguage;
  });

  const handleSetLanguage = useCallback(
    (value: CodeLanguageType) => {
      setLanguage(value);
      localStorage.setItem(`ls:ui:${prefix}code_language`, value);
    },
    [prefix]
  );

  return [language, handleSetLanguage] as const;
}
